("use strict");

const state = {
	doShowLoading: false
};

const getters = {
	getLoading: (state) => state.doShowLoading,
	getDoShowLoading: (state) => state.doShowLoading
};

const actions = {
	showLoading({commit}) {
		commit('setLoading', true);
	},
	hideLoading({commit}) {
		commit('setLoading', false);
	},
};

const mutations = {
	setLoading: (state, payload) => {
		state.doShowLoading = payload;
	},
};

export default {state, getters, actions, mutations};
